import { Injectable } from '@angular/core';
import { BaseReportActionsHandler } from '../base-report-actions-handler';
import { Override } from '../../../app-decorators';
import { GaMessageService, IDialog } from '../../../message/ga-message.service';
import { GaEventService, IGAEvent } from '../../../services/ga-event.service';
import { GaDeferredService, IGADeferred } from '../../../services/ga-deferred.service';
import { REPORT_ACTION_CANCELLED } from '../report-actions.helper';
import { FormsComponent } from '../../../../main/forms/forms.component';
import * as _ from 'underscore';
import { IObject } from '../../../../../type_definitions/datatypes';
import { IGA3ReportAction } from '../report-actions-config.service';
import { EVENT_REPORT_ACTION_DONE } from '../../../app-events';

@Injectable()
export class Ga3FormHandlerService extends BaseReportActionsHandler {

  private ga3FormDialog: IDialog;
  private deferred: IGADeferred<any>;

  constructor(
    private messageService: GaMessageService,
    private eventService: GaEventService,
    private deferredService: GaDeferredService
  ) {
    super();
  }

  @Override(BaseReportActionsHandler)
  public execute(): Promise<any> {
    this.deferred = this.deferredService.defer();

    // register listener
    this.listen();

    const ga3Config: IGA3ReportAction = {
      formId: this.action.ga3FormID,
      key: this.action.ga3FormKey,
      init: this.action.ga3CustomAction
    };

    this.ga3FormDialog = this.messageService.showDialog({
      component: FormsComponent,
      inputs: {
        formId: this.action.ga3FormID,
        key: this.getKeys(this.action.ga3FormKey),
        isReportAction: true,
        reportActionConfig: ga3Config,
        isInDialog: true,
        reportId: this.reportId
      },
      outputs: {
        onDialogCancel: this.onCancel,
        onSaved: this.onSaved
      },
      wrapperComponent: false
    });

    return this.deferred.promise;
  }

  private listen(): void {
    this.eventHandler = this.eventService.events.subscribe((evt: IGAEvent) => {
      if (evt.name === EVENT_REPORT_ACTION_DONE) {
        this.onClose();
      }
    });
  }

  private getKeys(key: string): string[] {
    if (!key) {
      return;
    }

    const keys: string[] = [];

    _.each(this.rowSelection, (selection: IObject) => {
      keys.push(selection[key]);
    });

    return keys;
  }

  private onCancel = (): void => {
    this.onClose();
    this.deferred.reject(REPORT_ACTION_CANCELLED);
  };

  private onSaved = (keyValue: string | number): void => {
    this.deferred.resolve(keyValue);
  };

  private onClose(): void {
    this.ga3FormDialog.hide();
    this.eventHandler.unsubscribe();
  }
}